import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, NavigationEnd } from '@angular/router';
import { AppTokenHandler } from '../common/app-token-handler';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DataService } from '../common/data.service';
import { AppInsightsService } from '../common/app-insights.service'; 

@Injectable()
export class AuthGuardService implements CanActivate {
    constructor(private appToken: AppTokenHandler, private route: Router, private gservice: DataService, private appInsightsService: AppInsightsService) {
        this.route.events.forEach((event) => {
            if (event instanceof NavigationEnd) {
                debugger;
                this.LogPageAnalytics();
            }
        });
    }
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.appToken.getSessionToken().length > 0) {
            return true;
        }
        this.route.navigate(['/unauthorize']);
    };
    LogPageAnalytics() {
        debugger;
        if (environment.logApplicationInsights == 'Y') {
            debugger;
            let username: string = '';
            let userInfo: any = this.appToken.getLoginUserInfo();
            debugger;
            if (userInfo && userInfo.empGPN) {
                debugger;
                username = userInfo.empGPN;
                this.appInsightsService.trackPageView(
                    window.location.href.replace('#/', ''),
                    username
                );
            }
        }
    }
}